import React, { useEffect } from 'react';

import glasses from '../visionsimulator/images/glasses.png';
import GlareYes from './images/glareYes.jpeg'
import GlareNo from './images/glareNo.jpeg'
import BackArrow from "../partials/BackArrow";
import monofocalImg from './images/monofocalFocusUnlabeled.jpeg'
import toricImg from './images/toricFocusUnlabeled.jpeg'
import toricEdofImg from './images/edofToricFocusUnlabeled.jpeg'
import edofImg from './images/edofFocusUnlabeled.jpeg'
import toricTrifocalImg from './images/trifocalToricFocusUnlabeled.jpeg'
import trifocalImg from './images/trifocalFocusUnlabeled.jpeg'
import PrintPage from "../partials/PrintPage";

export default function Summary(props) {
    // console.log(props.staticLensListOptions[0].lensName)


   let deviceType = (window.innerWidth <= 900 && window.innerHeight >= window.innerWidth)
    ? 'portrait'
    : (window.innerWidth <= 900 && window.innerHeight <= window.innerWidth)
    ? 'landscape'
    : 'full'

    // console.log(deviceType)


    let l = [];
    if (props.lensData && Array.isArray(props.lensData)) {
      l = props.lensData.filter(lens => (
        lens.lens_name === props.lensOption
      ));
    }
    // console.log(l)


  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  let imgStyle = {
    width: deviceType === 'full' ? '300px' : '100%',
    borderRadius: '20px',
    maxWidth: '300px',
  }


let columnStyle = {
  display:'flex',
  justifyContent: 'center',
}

let rowStyle = {
  display: 'flex', 
  justifyContent: 'space-evenly',
  // borderBottom: "1px solid #292929",
  padding: "8px 0 60px 0",
}
  
let pStyle={
  fontSize: '20px',
  margin: '0px 0 10px 0',
  textAlign: 'center',
}


  return (
    <div style={{display:'flex', background: "#FFF", margin: "40px 0 0 0"}}>
      <div style={{width: '7vw'}}></div>
      <div style={{width: '84vw'}}>
        <BackArrow
          linkTo='/visionsimulator'
        />
        <div style={{margin: "40px 0 300px 0"}}>
                    <div
                    >
                      <div 
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        {/* {
                            (
                              l[0].corrects_near_vision === "Yes" 
                              && 
                              l[0].corrects_intermediate_vision === 'Yes'
                              &&
                              l[0].lens_astig_min === '0'
                            )
                              ? 
                                <img
                                  src={trifocalImg}
                                  style={imgStyle}
                                />
                            : 
                            (
                              l[0].corrects_near_vision === "Yes" 
                              && 
                              l[0].corrects_intermediate_vision === 'Yes'
                              &&
                              l[0].lens_astig_min*1 > 0
                            )
                              ? 
                                <img
                                  src={toricTrifocalImg}
                                  style={imgStyle}
                                />
                            : 
                            (
                              l[0].corrects_near_vision === "No" 
                              && 
                              l[0].corrects_intermediate_vision === 'Yes'
                              &&
                              l[0].lens_astig_min === "0"
                            )
                              ? 
                                <img
                                  src={edofImg}
                                  style={imgStyle}
                                />
                            : 
                            (
                              l[0].corrects_near_vision === "No" 
                              && 
                              l[0].corrects_intermediate_vision === 'Yes'
                              &&
                              l[0].lens_astig_min*1 > 0
                            )
                              ? 
                                <img
                                  src={toricEdofImg}
                                  style={imgStyle}
                                />
                            : 
                            (
                              l[0].corrects_near_vision === "No" 
                              && 
                              l[0].corrects_intermediate_vision === 'No'
                              &&
                              l[0].lens_astig_min*1 > 0
                            )
                              ? 
                                <img
                                  src={toricImg}
                                  style={imgStyle}
                                />
                            : 
                                <img
                                  src={monofocalImg}
                                  style={imgStyle}
                                />
                          } */}
                        </div>
                        <div style={{margin: "0"}}>
                          <div 
                            style={{
                              display:'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <div>
                                <p 
                                  style={{
                                    fontSize: '46px',
                                    color: '#292929',
                                    margin: "20px 0 0 0",
                                    textAlign: 'center',
                                    maxWidth: '600px',
                                  }}
                                >
                                  {props.lensOption}
                                </p>
                                {
                                  props.lensTargetNear === true
                                  ? 
                                    <p
                                      style={{
                                        fontSize: '26px',
                                        color: '#292929',
                                        margin:'0',
                                        textAlign: 'center',
                                      }}
                                    >
                                      Set for near
                                    </p>
                                  : null
                                }                               
          
                          </div>
            
                        </div>
                      </div>
                      
                      
                      <div>
                        <div 
                          style={{
                            display: 'flex',
                            margin: '40px 0 0 0'
                            }} 
                        >
                          <div 
                            style={{
                              width: '120px',
                            }}
                          >
                            
                          </div>
                        </div>
                        
                    <hr
                      style={{
                        fontSize: '26px',
                        margin: '0px auto 0 auto',
                        width: '70%',
                      }}
                      className='dontPrint'
                    />


              <div style={rowStyle}>
                <div style={columnStyle}>
                  <div
                      style={{
                        width: deviceType === 'full' ? '600px' : '100%',
                        textAlign: 'center',
                      }}
                    >
                      {
                        props.oopTotal*1 === 0
                        ? 
                        <>
                          <p 
                            style={{
                              fontSize: '40px', 
                              fontWeight: '600px',
                              margin: "0",
                              }}>
                                Covered by insurance
                            </p>
                        </>
                        : 
                        <>
                          <p 
                            style={{
                              fontSize: '40px', 
                              fontWeight: '600px',
                              margin: "0",
                              }}>
                                ${props.refractiveFee*1 + props.oopHospital*1} 
                            </p>
                          <p style={pStyle}>  
                            out-of-pocket per eye
                          </p> 
                        </>
                      } 
                  </div>        
                </div>
              </div>
              
                    <hr
                      style={{
                        fontSize: '26px',
                        margin: '0px auto 0 auto',
                        width: '70%',
                      }}
                      className='dontPrint'
                    />


              {/* <div style={rowStyle}>
                <div style={columnStyle}>
                  <div
                    style={{
                      width: deviceType === 'full' ? '600px' : '100%',
                      textAlign: 'center',
                    }}
                  >
                
                {
                    props.bestSelected === true
                    ? 
                    <>
                        <p 
                        style={{
                            fontSize: '40px', 
                            fontWeight: '600px',
                            margin: '0',
                        }}>
                            Rare
                        </p>   
                        <p style={pStyle}>
                            need for glasses after surgery
                        </p>
                        <img
                          src={glasses}
                          style={{
                                  width: deviceType === 'full' ? '600px' : '100%',
                                  maxWidth: '300px',
                                  borderRadius: '8px',
                                  opacity: "0.1",
                              }}
                          alt='Need for glasses'
                        />
                    </>
                    : props.toricSelected || (props.edofLens.lens_name?.length > 0 || props.trifocalLens.lens_name?.length > 0)

                    ? 
                    <>
                        <p 
                        style={{
                            fontSize: '40px', 
                            fontWeight: '600px',
                            margin: '0',
                        }}>
                          {
                            props.lensTargetNear === true
                            ? 'Distance '
                            : 'Near '
                          }
                            glasses 
                        </p>  
                        <p style={pStyle}>
                          needed after surgery
                        </p>
                        <img
                          src={glasses}
                          style={{
                                  width: deviceType === 'full' ? '600px' : '100%',
                                  maxWidth: '300px',
                                  borderRadius: '8px',
                                  opacity: "0.5",
                              }}
                          alt='Need for glasses'
                        />
                    </>
                    : 
                    <>
                        <p 
                        style={{
                            fontSize: '40px', 
                            fontWeight: '600px',
                            margin: '0',
                        }}>
                            Full time
                        </p>   
                        <p style={pStyle}>
                            need for glasses after surgery
                        </p>
                        <img
                          src={glasses}
                          style={{
                                  width: deviceType === 'full' ? '600px' : '100%',
                                  maxWidth: '300px',
                                  borderRadius: '8px',
                                  opacity: "1",
                              }}
                          alt='Need for glasses'
                        />
                    </>
                }
                    
                  </div>
                </div>
              </div>

        {props.bestSelected === true 
          ? 
            <>
              <hr
                style={{
                  fontSize: '26px',
                  margin: '0px auto 0 auto',
                  width: '70%',
                }}
                className='dontPrint'
              />


              <div style={rowStyle}>
                <div style={columnStyle}>
                  <div
                      style={{
                        width: deviceType === 'full' ? '600px' : '100%',
                        textAlign: 'center',
                      }}
                    >
                      <>
                          <p 
                              style={{
                                  fontSize: '40px', 
                                  fontWeight: '600px',
                                  margin: '0',
                              }}>
                              Some
                          </p> 
                          <p style={{
                            fontSize: '20px',
                            margin: '0px 0 10px 0',
                            textAlign: 'center',
                          }}>
                            glare and halos around lights
                          </p> 
                          <img
                            src={GlareYes}
                            style={{
                                    width: deviceType === 'full' ? '600px' : '100%',
                                    maxWidth: '300px',
                                    borderRadius: '8px',
                                }}
                            alt='Glare and halos'
                          /> 
                      </>
                  </div>            
                </div>
              </div>
              </>
            : null
     } */}

                    </div>
                    <hr
                      style={{
                        fontSize: '26px',
                        margin: '0px auto 0 auto',
                        width: '70%',
                      }}
                      className='dontPrint'
                    />
                    <div
                      style={{
                        textAlign: 'center',
                        fontSize: '26px',
                        margin: '20px 0 0 0'
                      }}
                      className='dontPrint'
                    >
                      You have completed the simulation.  
                    </div>
                    <div
                      style={{
                        textAlign: 'center',
                        fontSize: '20px',
                        margin: '5px 0 0 0'
                      }}
                      className='dontPrint'
                    >
                      Please let your doctor know which lens you have chosen.
                    </div>
                    {
                      deviceType === 'full' 
                      ? 
                        <div
                          className="dontPrint"
                        >
                          <PrintPage/>
                        </div>
                      : null
                    }
                  </div>
  
        </div>        
      </div>
      <div style={{width: '7vw'}}></div>
      
    </div>
  )
}


